import React, { FunctionComponent, useState, useEffect, useCallback, useRef } from 'react';
import {
    Box,
    makeStyles,
    Theme,
    Grid,
    Button,
    DialogTitle,
    DialogActions,
    Dialog,
    DialogContent,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { grey } from '@material-ui/core/colors';
import classNames from 'classnames';
import { Select, MenuItem, InputBase, createStyles, withStyles } from '@material-ui/core';
import { Alert, Skeleton } from '@material-ui/lab';
import { KeyboardArrowLeft, KeyboardArrowRight, KeyboardArrowDown } from '@material-ui/icons';
import { Form as FormEngine, FormDefinition } from '@mylicenseone/forms';
import { uniq } from 'lodash';
import Header from '../../components/PageHeader/Header';
import Title from '../../components/PageHeader/Title';
import Files from './Tabs/Files';
import AuditHistory from './Tabs/AuditHistory';
import LicenseData from './Tabs/LicenseData';
import Accounting from './Tabs/Accounting';
import Comment from './Tabs/Comment';
import { AuditEventList, Order, TabList } from '../../store/modules/application/types';
import {
    Application,
    BreadCrumbs,
    Form,
    InspectionList,
    ViolationList,
    ViolationsCountFiltersType,
    LicenseTypeConfiguration,
    ViolationCategory,
    WorkflowTransition,
} from '../../store/modules/application/types';
import Loader from '../../components/Loader';
import LicenseDetail from './LicenseDetail';
import PageNotFound from '../../components/PageNotFound';
import {
    DETAILS_TAB_LIST,
    INSPECTIONS,
    CUSTOM_TAB_IDS,
    APP_STATUS_PENDING,
    APP_STATUS_ACTIVE,
    LICENSE_STATUS,
    APP_STATUS_INACTIVE,
    APP_STATUS_DENIED,
} from '../../store/app.constants';
import TabPanel from '../../components/TabPanel';
import DetailPageComponent from '../../components/DetailPageComponent/';
import Violation from './Tabs/Violation';
import Inspection from './Tabs/Inspection';
import BreadCrumb from '../../components/BreadCrumb';
import { BASE_URL } from '../../routes';
import { Person } from '../../store/modules/person/types';
import { getPersonSimpleName } from '../../utils/utils';
import { useAuthenticationContext } from '../../authentication';
import { Api } from '../../store/services/services';
import { siteActions } from '../../store/actions';
import FormFieldDisplay from '../../components/FormDisplay/FormFieldDisplay';
import { extractFormData, restoreRecord } from '../../components/FormDisplay/FormDisplay';
import { ErrorState } from '../../components/FormDisplay/types';
import { NotificationType } from 'src/store/modules/site/types';
import { File } from '../../store/modules/application/types';

type LicenseDetailTabsProps = {
    match: { params: { id: string } };
    application: Application;
    licenseType: LicenseTypeConfiguration;
    editForm: Form;
    getApplication: Function;
    getFileList: Function;
    getViolationList: Function;
    getCommentList: Function;
    getInspectionList: Function;
    getCategoryList: Function;
    getAuditHistoryList: Function;
    getLicenseAccounting: Function;
    isLoading: boolean;
    updateLicense: Function;
    applicationStatus: string;
    applicationPersonAddressStringify: string;
    appSiteFeatureList: [];
    violationCategories: ViolationCategory[];
    addInspection: Function;
    addComment: Function;
    users: [];
    getUserList: Function;
    inspectionTypesList: [];
    getInspectionTypeList: Function;
    inspectionEditForm: Form;
    setActiveTab: Function;
    personDetail: Person;
    inspectionList: InspectionList;
    hasMoreInspection: boolean;
    hasMoreViolation: boolean;
    loggedInUser: any;
    inspectionListLoading: boolean;
    hasMoreLicenseComments: boolean;
    deleteInspection: Function;
    hasMoreAccounting: boolean;
    addViolation: Function;
    deleteViolation: Function;
    violations: ViolationList;
    handleAddViolation: Function;
    violationsLoading: boolean;
    historyList: AuditEventList;
    historyLoading: boolean;
    hasMoreHistory: boolean;
    configuredTabs: TabList;
};

const LicenseDetailTabs: FunctionComponent<LicenseDetailTabsProps> = (props) => {
    const {
        getApplication,
        isLoading,
        application,
        applicationStatus,
        licenseType,
        editForm,
        getViolationList,
        getInspectionList,
        getCommentList,
        getAuditHistoryList,
        appSiteFeatureList,
        getCategoryList,
        addViolation,
        addComment,
        getUserList,
        setActiveTab,
        personDetail,
        inspectionList,
        hasMoreInspection,
        hasMoreViolation,
        historyList,
        hasMoreHistory,
        historyLoading,
        inspectionListLoading,
        hasMoreLicenseComments,
        addInspection,
        deleteInspection,
        hasMoreAccounting,
        getLicenseAccounting,
        deleteViolation,
        violations,
        violationsLoading,
        configuredTabs,
    } = props;

    const authContext = useAuthenticationContext();
    const getAccessToken = authContext.getAccessToken;
    const authorizationScopes = authContext.scopes;
    const dispatch = useDispatch();

    const [transitionFormOpen, setTransitionFormOpen] = useState(false);
    const [transitionFormId, setTransitionFormId] = useState<string>();
    const [transitionForm, setTransitionForm] = useState<Form>();
    const [transitionFormData, setTransitionFormData] = useState<Record<string, unknown>>({});
    const [formEngine, setFormEngine] = useState<FormEngine>();
    const [formErrors, setFormErrors] = useState<Record<string, ErrorState>>({});
    const [transitionToStatus, setTransitionToStatus] = useState<string>('');
    const [doShowDetail, setDoShowDetail] = useState(true);
    const [tabList, setTabList] = useState<TabList>();
    const [breadCrumbs, setBreadCrumbs] = useState<BreadCrumbs>();
    const [statusList, setStatusList] = useState<string[]>();
    const [transitions, setTransitions] = useState<WorkflowTransition[]>();

    const [openViolationsCount, setOpenViolationsCount] = useState<number>(0);
    const [skipViolation, setSkipViolation] = useState<number>(0);
    const [skipComment, setSkipComment] = useState<number>(0);
    const [skipAccounting, setSkipAccounting] = useState<number>(0);
    const [skipInspection, setSkipInspection] = useState<number>(0);
    const [skipHistory, setSkipHistory] = useState<number>(0);

    const [files, setFiles] = useState<File[]>([]);
    const [getFilesErrorStatus, setGetFilesErrorStatus] = useState<boolean>(false);
    const [isGetFilesLoading, setGetFilesLoading] = useState<boolean>(false);
    const [fileRequestTrigger, setFileRequestTrigger] = useState<{ state: boolean; tracker: number }>({
        state: false,
        tracker: 0,
    });
    const [loadMoreFiles, setLoadMoreFiles] = useState<boolean>(false);
    const [deletedFilesCount, setDeletedFilesCount] = useState<number>(0);

    const inspectionLimit = 20;
    const violationLimit = 20;
    const fileLimit = 20;
    const commentLimit = 20;
    const accountingLimit = 20;
    const historyLimit = 20;

    //TODO: Need to dynamically set the sortOrder in future
    const [inspectionSortOrder, setInspectionSortOrder] = useState<Order>('desc');
    const [inspectionSortColumn, setInspectionSortColumn] = useState<string>('inspectionDate');

    //TODO: Need to dynamically set the sortOrder in future
    const [violationSortOrder, setViolationSortOrder] = useState<Order>('desc');
    const [violationSortColumn, setViolationSortColumn] = useState<string>('inspection.inspectionDate desc');

    const [historySelectedCategory, setHistorySelectedCategory] = useState<string>('All');
    const [historyPhrases, setHistoryPhrases] = useState<{ phrase: string[]; date: string; id: string }[]>([]);

    const applicationId = props.match.params.id;
    const isAppSiteInspection = appSiteFeatureList?.find((siteName) => siteName === INSPECTIONS);
    const titleText = application.type?.name + ` ${application.licenseNumber ?? ''}`;
    const assignNumberOnApproval =
        !licenseType.licenseNumbers?.requiredOnEntry && !licenseType.licenseNumbers?.licenseNumberMaskId;

    const makeBreadCrumbs = useCallback(() => {
        if (personDetail && personDetail.id) {
            return [
                {
                    label: `${getPersonSimpleName(personDetail.name)} `,
                    path: BASE_URL + `/person/${personDetail && personDetail.id}/detail`,
                },
            ];
        }
        return [];
    }, [personDetail]);

    useEffect(() => {
        getApplication(applicationId);
        isAppSiteInspection && getUserList();
    }, [isAppSiteInspection, applicationId, getUserList, getApplication]);

    useEffect(() => {
        getLicenseAccounting(applicationId, {
            limit: accountingLimit,
            skip: skipAccounting,
        });
    }, [applicationId, getLicenseAccounting, skipAccounting]);

    useEffect(() => {
        isAppSiteInspection &&
            getViolationList(applicationId, {
                limit: violationLimit,
                skip: skipViolation,
                orderCol: violationSortColumn,
                orderBy: violationSortOrder,
            });
    }, [isAppSiteInspection, getViolationList, applicationId, skipViolation, violationSortOrder, violationSortColumn]);

    useEffect(() => {
        isAppSiteInspection &&
            getInspectionList(applicationId, {
                limit: inspectionLimit,
                skip: skipInspection,
                orderCol: inspectionSortColumn,
                orderBy: inspectionSortOrder,
            });
    }, [
        isAppSiteInspection,
        getInspectionList,
        applicationId,
        skipInspection,
        inspectionSortColumn,
        inspectionSortOrder,
    ]);

    const removeDeletedFile = (fileId: string) => {
        setFiles((prevState) => prevState.filter((file) => file.id !== fileId));

        setDeletedFilesCount((prevState) => ++prevState);
    };

    const toggleFileRequestTrigger = (resetTracker?: boolean) => {
        if (resetTracker) {
            setDeletedFilesCount(0);
        }

        setFileRequestTrigger((prevState) => ({
            state: !prevState.state,
            tracker: resetTracker ? 0 : ++prevState.tracker,
        }));
    };

    useEffect(() => {
        // Account for scenario with deleted files to keep the skip in sync.
        const skip = (fileRequestTrigger.tracker + 1) * fileLimit - deletedFilesCount;

        // If the file length is less that the skip that indicates we've loaded all
        // the files and we don't need to load more.
        setLoadMoreFiles(files.length >= skip);
    }, [fileRequestTrigger, files, deletedFilesCount, setLoadMoreFiles]);

    useEffect(() => {
        (async function () {
            setGetFilesLoading(true);

            const token = await getAccessToken({ scopes: [authorizationScopes['licenses.read']] });

            try {
                // Account for scenario with deleted files to keep the skip in sync.
                const skip = fileRequestTrigger.tracker * fileLimit - deletedFilesCount;

                const data = await Api.getFilesList(token.accessToken, applicationId, { limit: fileLimit, skip });

                // If the tracker is 0 then there is no skipping which means it's a new list of files.
                fileRequestTrigger.tracker ? setFiles((prevState) => prevState.concat(data)) : setFiles(data);

                setGetFilesErrorStatus(false);
            } catch (err) {
                setFiles([]);

                setGetFilesErrorStatus(true);
            } finally {
                setGetFilesLoading(false);
            }
        })();
        // eslint-disable-next-line
    }, [
        getAccessToken,
        setFiles,
        applicationId,
        authorizationScopes,
        setGetFilesErrorStatus,
        setLoadMoreFiles,
        fileRequestTrigger.state,
    ]);

    useEffect(() => {
        getCommentList(applicationId, { limit: commentLimit, skip: skipComment });
    }, [getCommentList, skipComment, applicationId]);

    useEffect(() => {
        getAuditHistoryList(applicationId, historySelectedCategory, { limit: historyLimit, skip: skipHistory });
    }, [getAuditHistoryList, applicationId, skipHistory, historySelectedCategory]);

    const setTabListBasedOnFeatureFlag = useCallback(async () => {
        if (isAppSiteInspection) {
            setTabList(DETAILS_TAB_LIST);
        } else {
            setTabList(DETAILS_TAB_LIST.filter((item) => !CUSTOM_TAB_IDS.includes(item.id)));
        }
    }, [isAppSiteInspection]);

    useEffect(() => {
        if (!configuredTabs) {
            setTabListBasedOnFeatureFlag();
        } else {
            setTabList(configuredTabs);
        }
    }, [setTabListBasedOnFeatureFlag, configuredTabs]);

    useEffect(() => {
        isAppSiteInspection &&
            application?.type?.id &&
            getCategoryList({
                licenseTypeId: application?.type?.id,
            });
        // eslint-disable-next-line
    }, [application?.type?.id]);

    useEffect(() => {
        const response = makeBreadCrumbs();
        setBreadCrumbs(response);
    }, [makeBreadCrumbs]);

    const getStatusList = useCallback(async () => {
        let statuses: string[] | undefined;

        if (licenseType.workflowId) {
            const token = await getAccessToken({ scopes: [authorizationScopes['workflows.read']] });

            const transitions: WorkflowTransition[] | undefined = await Api.getWorkflowTransitions(
                token.accessToken,
                licenseType.workflowId,
                application.status,
            );

            setTransitions(transitions);

            statuses = transitions?.map((transition) => transition.nextState).concat(application.status);
        } else {
            setTransitions(undefined);
        }

        setStatusList(uniq((statuses ?? LICENSE_STATUS).sort()));
    }, [licenseType.workflowId, application.status, getAccessToken, authorizationScopes]);

    useEffect(() => {
        if (licenseType.id) {
            getStatusList();
        }
    }, [licenseType.id, getStatusList]);

    const getOpenViolationsCount = useCallback(async () => {
        const filters: ViolationsCountFiltersType = { status: 'Found' };
        try {
            const token = await getAccessToken({ scopes: [authorizationScopes['violations.read']] });
            const response = await Api.getViolationsCount(token.accessToken, applicationId, filters);
            response && setOpenViolationsCount(response.count);
        } catch (err) {
            dispatch(siteActions.setError(err as NotificationType));
        }
    }, [applicationId, getAccessToken, dispatch, authorizationScopes]);

    useEffect(() => {
        isAppSiteInspection && getOpenViolationsCount();
        // we want this effect to also run everytime 'violations' is updated e.g. a violation is deleted and page is not refreshed
    }, [isAppSiteInspection, getOpenViolationsCount, violations]);

    const getTransitionForm = useCallback(async () => {
        if (transitionFormId) {
            const token = await getAccessToken({ scopes: [authorizationScopes['forms.read']] });

            try {
                const form = await Api.getForm(token.accessToken, transitionFormId);

                setTransitionFormData(extractFormData(application, form));
                setTransitionForm(form);
            } catch (err) {
                dispatch(siteActions.setError(err as NotificationType));
            }
        } else {
            setTransitionForm(undefined);
        }
    }, [transitionFormId, application, dispatch, getAccessToken, authorizationScopes]);

    useEffect(() => {
        getTransitionForm();
    }, [getTransitionForm]);

    const formErrorsRef = useRef<Record<string, ErrorState>>({});

    useEffect(() => {
        formEngine?.evaluateApplicationData(transitionFormData, { validateDefinedOnly: true });
    }, [formEngine, transitionFormData]);

    useEffect(() => {
        if (transitionForm?.sections) {
            const engine = new FormEngine(transitionForm as FormDefinition);

            engine.onValidationChange((field, error, messages) => {
                formErrorsRef.current = {
                    ...formErrorsRef.current,
                    [field]: {
                        error,
                        messages,
                    },
                };

                setFormErrors(formErrorsRef.current);
            });

            setFormEngine(engine);
        } else {
            setFormEngine(undefined);
        }

        setFormErrors({});
    }, [transitionForm]);

    const handleStatusChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const newStatus = event.target.value as string;

        setTransitionFormId(undefined);
        setTransitionForm(undefined);

        if (newStatus !== application.status) {
            const transition = transitions?.find((item) => item.nextState === newStatus);
            let requiresAdditionalInput = false;

            if (transition) {
                // If there is a defined transition, check if the transition requires
                // additional user input.
                if (transition.formId) {
                    setTransitionFormData({});
                    setTransitionFormId(transition.formId);
                    requiresAdditionalInput = true;
                }
            } else {
                // No defined transition, display form only if changing to Active status.
                if (newStatus === APP_STATUS_ACTIVE) {
                    // Dynamically build entry form based on whether license number entry
                    // is required.
                    const form: Form = {
                        id: 'defaultIssuanceForm',
                        name: 'License Activation',
                        sections: [{ name: 'License Information', entries: [] }],
                    };

                    if (assignNumberOnApproval) {
                        form.sections[0].entries.push({
                            field: 'licenseNumber',
                            typeId: 'shortText',
                            label: 'License Number',
                            fieldMapping: {
                                targetPath: '$.licenseNumber',
                            },
                            rules: [
                                {
                                    conditions: {
                                        all: [
                                            {
                                                fact: 'licenseNumber',
                                                operator: 'hasValue',
                                                value: true,
                                            },
                                        ],
                                    },
                                    event: {
                                        type: 'licenseNumberRequired',
                                        params: {
                                            message: 'Required Field',
                                        },
                                    },
                                },
                            ],
                        });
                    }

                    form.sections[0].entries.push(
                        {
                            typeId: 'date',
                            field: 'issueDate',
                            label: 'Issue Date',
                            fieldMapping: {
                                targetPath: '$.issueDate',
                            },
                            rules: [
                                {
                                    conditions: {
                                        all: [
                                            {
                                                fact: 'issueDate',
                                                operator: 'hasValue',
                                                value: true,
                                            },
                                        ],
                                    },
                                    event: {
                                        type: 'issueDateRequired',
                                        params: {
                                            message: 'Required Field',
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            typeId: 'date',
                            field: 'expirationDate',
                            label: 'Expiration Date',
                            fieldMapping: {
                                targetPath: '$.expirationDate',
                            },
                            rules: [
                                {
                                    conditions: {
                                        all: [
                                            {
                                                fact: 'expirationDate',
                                                operator: 'hasValue',
                                                value: true,
                                            },
                                        ],
                                    },
                                    event: {
                                        type: 'expirationDateRequired',
                                        params: {
                                            message: 'Required Field',
                                        },
                                    },
                                },
                            ],
                        },
                    );

                    setTransitionFormData(extractFormData(application, form));
                    setTransitionForm(form);
                    requiresAdditionalInput = true;
                }
            }

            if (requiresAdditionalInput) {
                setTransitionToStatus(newStatus);
                setTransitionFormOpen(true);
            } else {
                props.updateLicense({ status: newStatus }, applicationId);
            }
        }
    };

    const handleInputChange = (dataKey: string, value: unknown) => {
        setTransitionFormData({
            ...transitionFormData,
            [dataKey]: value,
        });
    };

    const BootstrapInput = withStyles((theme: Theme) =>
        createStyles({
            root: {
                'label + &': {
                    marginTop: theme.spacing(3),
                    width: '100%',
                },
            },
            input: {
                borderRadius: 4,
                position: 'relative',
                backgroundColor: theme.palette.background.paper,
                border: '1px solid #ced4da',
                fontSize: 16,
                padding: '10px 26px 10px 12px',
                transition: theme.transitions.create(['border-color', 'box-shadow']),
                // Use the system font instead of the default Roboto font.
                fontFamily: [
                    '-apple-system',
                    'BlinkMacSystemFont',
                    '"Segoe UI"',
                    'Roboto',
                    '"Helvetica Neue"',
                    'Arial',
                    'sans-serif',
                    '"Apple Color Emoji"',
                    '"Segoe UI Emoji"',
                    '"Segoe UI Symbol"',
                ].join(','),
                '&:focus': {
                    borderRadius: 4,
                    borderColor: '#80bdff',
                    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
                },
            },
        }),
    )(InputBase);

    const classes = makeStyles((theme: Theme) => ({
        statusBox: {
            margin: '8px 20px',
            color: '#6E7788',
            fontSize: 16,
        },
        violationsAlert: {
            background: 'none',
            color: theme.palette.error.dark,
        },
        pending: {
            color: theme.palette.info.dark,
            background: theme.palette.info.light,
        },
        active: {
            color: theme.palette.primary.main,
            background: grey[100],
        },
        inactive: {
            color: theme.palette.error.dark,
            background: theme.palette.error.light,
        },
        indicator: {
            backgroundColor: theme.palette.primary.main,
        },
        activationModal: {
            padding: 10,
        },
        modalHeader: {
            color: grey[800],
            fontSize: 20,
            fontWeight: 500,
            marginBottom: 20,
        },
        formInput: {
            backgroundColor: 'white',
            border: '1px solid grey',
            borderRadius: 5,
            '&:focus': {
                backgroundColor: 'white',
            },
            '&:hover': {
                backgroundColor: ['white', '!important'],
            },
        },
        underline: {
            '&:before': {
                borderBottomColor: 'white',
            },
            '&:after': {
                borderBottomColor: 'white',
            },
            '&:hover:before': {
                borderBottomColor: ['white', '!important'],
            },
        },
        inputFields: {
            marginTop: 15,
        },
        btnsContainer: {
            marginTop: 25,
        },
        modalBtn: {
            marginLeft: 20,
        },
        datePicker: {
            margin: 0,
        },
        datePickerContainer: {
            backgroundColor: 'white',
            border: '1px solid grey',
            borderRadius: 5,
            padding: '8px 12px 13px 12px',
            margin: '15px 0px',
        },
        btnContainer: {
            display: 'flex',
            flexGrow: 1,
            justifyContent: 'flex-end',
            '& button': {
                maxWidth: 100,
                alignSelf: 'center',
            },
        },
        uploadBtn: {
            minWidth: 120,
            fontSize: 12,
            marginBottom: 25,
        },
        violationContainer: {
            display: 'flex',
            flexGrow: 1,
            justifyContent: 'flex-end',
        },
        inspectionContainer: {
            display: 'flex',
            flexGrow: 1,
            justifyContent: 'flex-end',
        },
        addViolation: {
            color: '#0277BD',
            marginRight: '40px',
            fontWeight: 500,
            cursor: 'pointer',
            letterSpacing: '0.3px,',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '25px',
        },
        uploadButton: {
            color: '#0277BD',
            marginRight: '40px',
            fontWeight: 500,
            cursor: 'pointer',
            letterSpacing: '0.3px,',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '25px',
            justifyContent: 'flex-end',
        },
        detailNode: {
            paddingLeft: 0,
        },
    }))();

    const leftDetailBarStyle = classNames({
        'detail-container-closed': true,
        'detail-container-hidden': false,
    });

    const onTabSelect = (tabName: string) => {
        setActiveTab(tabName);
    };

    const updateInspectionSortBy = (sortBy: string) => {
        setInspectionSortColumn(sortBy);
        setSkipInspection(0);
    };

    const updateInspectionSortOrder = (sortOrder: Order) => {
        setInspectionSortOrder(sortOrder);
        setSkipInspection(0);
    };

    const updateViolationSortBy = (sortBy: string) => {
        setViolationSortColumn(sortBy);
        setSkipViolation(0);
    };

    const updateViolationSortOrder = (sortOrder: Order) => {
        setViolationSortOrder(sortOrder);
        setSkipViolation(0);
    };

    const renderTabsPanel = (activeTab: number) => {
        const tab = tabList && tabList[activeTab];

        switch (tab?.id) {
            case 'licenseData':
                return (
                    <TabPanel activeTab={activeTab} index={activeTab}>
                        <LicenseData application={application} editForm={editForm} />
                    </TabPanel>
                );
            case 'inspections':
                return (
                    <TabPanel activeTab={activeTab} index={activeTab}>
                        <Inspection
                            data={inspectionList}
                            loading={inspectionListLoading}
                            application={application}
                            addInspection={addInspection}
                            deleteInspection={deleteInspection}
                            hasMore={hasMoreInspection}
                            skip={skipInspection}
                            setSkip={setSkipInspection}
                            setSortColumn={updateInspectionSortBy}
                            setSortOrder={updateInspectionSortOrder}
                            sortOrder={inspectionSortOrder}
                            sortBy={inspectionSortColumn}
                        />
                    </TabPanel>
                );
            case 'violations':
                return (
                    <TabPanel activeTab={activeTab} index={activeTab}>
                        <Violation
                            data={violations}
                            loading={violationsLoading}
                            application={application}
                            deleteViolation={deleteViolation}
                            addViolation={addViolation}
                            skip={skipViolation}
                            setSkip={setSkipViolation}
                            hasMore={hasMoreViolation}
                            setSortColumn={updateViolationSortBy}
                            setSortOrder={updateViolationSortOrder}
                            sortOrder={violationSortOrder}
                            sortBy={violationSortColumn}
                        />
                    </TabPanel>
                );
            case 'files':
                return (
                    <TabPanel activeTab={activeTab} index={activeTab}>
                        <Files
                            applicationId={applicationId}
                            data={files}
                            limit={fileLimit}
                            toggleFileRequestTrigger={toggleFileRequestTrigger}
                            hasMore={loadMoreFiles}
                            errorStatus={getFilesErrorStatus}
                            loading={isGetFilesLoading}
                            removeDeletedFile={removeDeletedFile}
                        />
                    </TabPanel>
                );
            case 'accounting':
                return (
                    <TabPanel activeTab={activeTab} index={activeTab}>
                        <Accounting
                            person={application.person}
                            license={application}
                            limit={accountingLimit}
                            skip={skipAccounting}
                            setSkip={setSkipAccounting}
                            hasMore={hasMoreAccounting}
                            getAccounting={getLicenseAccounting}
                        />
                    </TabPanel>
                );
            case 'comments':
                return (
                    <TabPanel activeTab={activeTab} index={activeTab}>
                        <Comment
                            application={application}
                            addComment={addComment}
                            skip={skipComment}
                            setSkip={setSkipComment}
                            hasMore={hasMoreLicenseComments}
                            doShowDetail={doShowDetail}
                        />
                    </TabPanel>
                );
            case 'history':
                return (
                    <TabPanel activeTab={activeTab} index={activeTab}>
                        <AuditHistory
                            application={application}
                            skip={skipHistory}
                            setSkip={setSkipHistory}
                            hasMore={hasMoreHistory}
                            auditHistoryList={historyList}
                            loading={historyLoading}
                            selectedCategory={historySelectedCategory}
                            setSelectedCategory={setHistorySelectedCategory}
                            phrases={historyPhrases}
                            setPhrases={setHistoryPhrases}
                        />
                    </TabPanel>
                );
            default:
                return <h1>Something went wrong. We are on it.</h1>;
        }
    };

    const StatusHeader = () => {
        return (
            <>
                <Header>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                        <BreadCrumb breadCrumbs={breadCrumbs} />
                        <Box display="flex">
                            <Title titleText={titleText} />
                            {openViolationsCount > 0 && (
                                <Box display="flex" alignItems="flex-end">
                                    <Alert
                                        className={classes.violationsAlert}
                                        severity="error"
                                    >{`${openViolationsCount} OPEN VIOLATIONS`}</Alert>
                                </Box>
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                        <Box display="flex" alignItems="center" justifyContent="flex-end" mt={2} mb={2} ml={4} mr={4}>
                            <Box display="flex" className={classes.statusBox}>
                                Status
                            </Box>
                            {statusList ? (
                                <Select
                                    labelId="demo-customized-select-label"
                                    id="demo-customized-select"
                                    value={applicationStatus}
                                    IconComponent={KeyboardArrowDown}
                                    onChange={handleStatusChange}
                                    input={<BootstrapInput />}
                                    autoWidth={true}
                                    classes={{
                                        root: classNames({
                                            [classes.pending]: application?.status === APP_STATUS_PENDING,
                                            [classes.inactive]: [APP_STATUS_INACTIVE, APP_STATUS_DENIED].includes(
                                                application?.status,
                                            ),
                                            [classes.active]: ![
                                                APP_STATUS_PENDING,
                                                APP_STATUS_INACTIVE,
                                                APP_STATUS_DENIED,
                                            ].includes(application?.status),
                                        }),
                                    }}
                                >
                                    {statusList.map((status) => (
                                        <MenuItem key={status} value={status}>
                                            {status}
                                        </MenuItem>
                                    ))}
                                </Select>
                            ) : (
                                <Skeleton variant="text" width={100} height={40} />
                            )}
                        </Box>
                    </Grid>
                    <>
                        {doShowDetail && (
                            <KeyboardArrowLeft
                                className="detail-show-hide-btn opened"
                                onClick={() => {
                                    setDoShowDetail(!doShowDetail);
                                }}
                            />
                        )}
                        {!doShowDetail && (
                            <KeyboardArrowRight
                                className="detail-show-hide-btn closed"
                                onClick={() => {
                                    setDoShowDetail(!doShowDetail);
                                }}
                            />
                        )}
                    </>
                </Header>
                <>
                    {doShowDetail && (
                        <Box
                            className="backdrop"
                            onClick={() => {
                                setDoShowDetail(!doShowDetail);
                            }}
                        ></Box>
                    )}
                </>
            </>
        );
    };

    if (isLoading) {
        return <Loader />;
    }

    if (!isLoading && !application.id) {
        return <PageNotFound />;
    }

    return (
        <div className="verticalFillContainer">
            <StatusHeader />
            <Box width="100%" display="flex" className="detail detail-mobile verticalFillContent">
                <LicenseDetail className={leftDetailBarStyle} doShowDetail={doShowDetail} application={application!} />

                <DetailPageComponent
                    displayTabs={renderTabsPanel}
                    tabList={tabList}
                    onTabSelect={onTabSelect}
                ></DetailPageComponent>
            </Box>
            {/* Modal for License status change */}
            <Dialog open={transitionFormOpen} maxWidth={'sm'} fullWidth={true}>
                {(transitionFormId || transitionForm) && (
                    <>
                        <DialogTitle>{transitionForm ? transitionForm.name : <Skeleton width={100} />}</DialogTitle>
                        <DialogContent>
                            {transitionForm ? (
                                transitionForm.sections.flatMap((section) =>
                                    section.entries.map((entry) => (
                                        <Grid key={entry.field} container spacing={2}>
                                            <Grid item xs={12}>
                                                <FormFieldDisplay
                                                    formData={transitionFormData}
                                                    formField={entry}
                                                    value={transitionFormData[entry.field]}
                                                    error={formErrors[entry.field]}
                                                    readOnly={false}
                                                    handleInputChange={handleInputChange}
                                                    isCustomStyle={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    )),
                                )
                            ) : (
                                <>
                                    <Skeleton variant="rect" width="100%" height={30} />
                                    <br />
                                    <Skeleton variant="rect" width="100%" height={30} />
                                </>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                className={classes.modalBtn}
                                onClick={() => {
                                    setTransitionFormOpen(false);
                                    setTransitionFormId(undefined);
                                    setTransitionForm(undefined);
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                className={classes.modalBtn}
                                variant="contained"
                                color="primary"
                                disabled={!transitionForm || Object.values(formErrors).some((error) => error.error)}
                                onClick={async () => {
                                    await formEngine?.evaluateApplicationData(transitionFormData);

                                    if (!formEngine?.applicationHasErrors()) {
                                        const updatedLicense = {
                                            ...restoreRecord(application, transitionFormData, transitionForm!),
                                            status: transitionToStatus,
                                        };

                                        props.updateLicense(updatedLicense, applicationId);
                                        setTransitionFormOpen(false);
                                        setTransitionFormId(undefined);
                                        setTransitionForm(undefined);
                                    }
                                }}
                            >
                                Save
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
        </div>
    );
};

export default LicenseDetailTabs;
